<template>
  <div v-show="loading" :class="$style.loader">
    <v-progress-circular
      v-if="loading"
      :size="size"
      :width="width"
      :color="color"
      :indeterminate="loading"
    />
  </div>
</template>

<script>
export default {
  name: 'LoaderElement',
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
    size: {
      type: Number,
      default: 128,
    },
    width: {
      type: Number,
      default: 2,
    },
    color: {
      type: String,
      default: undefined,
    },
  },
}
</script>

<style lang="scss" module>
.loader {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1;

  display: flex;
  align-items: center;
  justify-content: center;

  background: rgba(255, 255, 255, 0.8);
  cursor: wait;
}
</style>
